import { Link } from 'react-router-dom';
import { categoriesData } from '@/mocks/films';

export default function CategoryPreview() {
  return (
    <section className="py-14 md:py-20 bg-background-100" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            作品分类
          </h2>
          <p className="mt-2 text-foreground-600 text-sm">
            按不同维度浏览北条麻妃的精彩作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categoriesData.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-6 text-center transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-4 font-heading font-semibold text-foreground-900 text-base whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}